import React from 'react';
import schema from './schema';
import uiSchema from './uiSchema';
import { MuiFormBuilder } from 'components';
import { useSelector } from 'react-redux';

const Form = ({ formData = {}, onChange }) => {
  const { userTypes } = useSelector((state) => state.models);
  const { userStatuses } = useSelector((state) => state.models);

  return (
    <MuiFormBuilder
      showSubmit={false}
      schema={schema(userTypes, userStatuses)}
      uiSchema={uiSchema()}
      formData={formData}
      onChange={onChange}
      liveValidate={false}
    />
  );
};

export default Form;
